import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px solid #0d84ff;
  background: #e9ebee;
  box-shadow: none;
  position: relative;

  overflow: hidden;

  .new-bot__wrapper-menu {
    position: absolute;
    left: -2px;
    right: -2px;
    top: -2px;
    bottom: -2px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: #444b56a8;
    backdrop-filter: blur(2px);
    top: 100%;
    height: 100%;
    transition: top 330ms ease-in-out;
  }

  :hover .new-bot__wrapper-menu {
    top: 0;
  }

  .new-bot__title {
    font-size: 20px;
    color: #fff;
    text-align: left;
    margin: 0px auto 12px 0px;
  }

  .new-bot__button {
    width: 100%;
    height: 35px;
    outline: none;
    font-size: 14px;
    color: #fff;
    border: none;
    border-radius: 5px;
    margin: 6px 0;
    transition: filter 0.2s;

    :hover {
      filter: brightness(0.9);
    }
  }

  .new-bot__button--orange {
    background: #f49400;
  }

  .new-bot__button--blue {
    background: #0d84ff;
  }
`;
